<jsg-single-row-panel
  *ngIf="!isUrgent; else urgentPanel"
  [backgroundStyleClass]="backgroundStyleClass"
>
  <div first>
    <div *ngIf="!isAdjournedPending && !isAdjournedSineDiePending; else adjournBlock">Hearing date</div>
    <ng-template #adjournBlock>
      <div>Adjourn to</div>
    </ng-template>
    <div *ngIf="!isAdjournedSineDiePending; else adjournSineDieDate">{{ hearingDate | date: 'MMM dd, yyyy' | incomplete }}</div>
    <ng-template #adjournSineDieDate>
      <div>Sine Die</div>
    </ng-template>
  </div>
  <div second>
    <div>Justice on duty</div>
    <div>
      <span *ngIf="justiceName && showJusticePrefix">Justice </span>{{ justiceName | incomplete }}
    </div>
  </div>
  <div third>
    <div>Hearing time (duration)</div>
    <div *ngIf="hearingDate; else noHearingTime">
      {{ hearingDate | date: 'h:mm a' }} -
      {{ getEndTime(hearingDate, hearingDuration) | date: 'h:mm a' }}
      ({{ hearingDuration }} minutes)
    </div>
    <ng-template #noHearingTime>
      <div class="section-text">——</div>
    </ng-template>
  </div>
</jsg-single-row-panel>

<ng-template #urgentPanel>
  <jsg-multi-row-panel>
    <jsg-single-row-panel first>
      <div first>
        <div>Urgent Request</div>
        <div>Yes</div>
      </div>
      <div second>
        <div>Time required</div>
        <div>{{ urgentTimeRequired }} min</div>
      </div>
    </jsg-single-row-panel>
    <jsg-single-row-panel second>
      <div first>
        <div>Reason for urgency</div>
        <div>{{ urgencyComments }}</div>
      </div>
    </jsg-single-row-panel>
    <jsg-single-row-panel third>
      <div first>
        <div>Dates desired</div>
        <div>{{ urgencyDates }}</div>
      </div>
    </jsg-single-row-panel>
  </jsg-multi-row-panel>
</ng-template>
